module.exports = "/images/loading.gif?ccca0bfbcd6ebff4663996a9ac2ed63c";